import { gql } from '@apollo/client'
import { MUTATION_STATE, VOOH_MEDIA_TREE_FIELDS } from 'api/fragments'

const PAYLOAD_TYPE = 'UpdateVoohCampaignPayload'

export const UPDATE_VOOH_CAMPAIGN = gql`
  ${VOOH_MEDIA_TREE_FIELDS}
  ${MUTATION_STATE(PAYLOAD_TYPE)}
  mutation updateVoohCampaign(
    $id: ID!
    $agencyId: ID
    $advertiserId: ID,
    $sourceMedia: VoohCampaignSourceMediaEnum!
    $name: String!
    $briefName: String!
    $startDate: ISO8601DateTime!
    $endDate: ISO8601DateTime!
    $supervisors: [ID!]
    $brandId: ID
    $networkId: ID
  ) {
    updateVoohCampaign(
      input: {
        id: $id
        agencyId: $agencyId
        advertiserId: $advertiserId
        sourceMedia: $sourceMedia
        name: $name
        briefName: $briefName
        startDate: $startDate
        endDate: $endDate
        supervisors: $supervisors
        brandId: $brandId
        networkId: $networkId
      }
    ) {
      voohCampaign {
        id
        publishable
        media {
          id
        }
        mediaTree {
          ...VoohMediaFields
        }
      }
      ...MutationState${PAYLOAD_TYPE}Fields
    }
  }
`
